// extracted by mini-css-extract-plugin
module.exports = {"resetBtn":"_2BnVT9GsWYMRxYTdG-2PiH","icon":"_2srbIfSoBB8RPYEdYBHWz-","active":"_yieK-2H3xodaQ1NcD_9R"};